<template>
  <div class="test-page">
    <div class="container" id="container"></div>
    <talk-modal></talk-modal>
  </div>
</template>

<script>
import STYLE from "@/common/mapfiles/style.json";
import { MAP_PK } from "@/common/constants";
import mapboxgl from "mapbox-gl";
export default {
  data() {
    return {
      map: null,
    };
  },
  methods: {
    initMap() {
      this.map = new mapboxgl.Map({
        container: "container",
        style: STYLE,
        accessToken: MAP_PK,
        center: [106.551556, 29.563009],
        zoom: 9,
      });
    },
  },
  mounted() {
    this.initMap();
  },
};
</script>

<style lang="less" scoped>
.test-page {
  width: 100%;
  height: 100%;
  .container {
    width: 100%;
    height: 100%;
  }
}
</style>